module.exports = __webpack_public_path__ + "media/fonts/TTCommons-Regular-a3a33746633037e50df40a943e251da0.woff2";